
export const initTooltips = () => {

    const $tooltips = document.querySelectorAll('.info-tooltip');

    $tooltips.forEach(img => {
        const tooltip = img.nextElementSibling;

        img.addEventListener('mouseenter', () => {
            if (tooltip && tooltip.classList.contains('tooltip-absolute')) {
                tooltip.classList.remove('hidden');
            }
        });

        img.addEventListener('mouseleave', () => {
            if (tooltip && tooltip.classList.contains('tooltip-absolute')) {
                tooltip.classList.add('hidden');
            }
        });
    });
};
